// extracted by mini-css-extract-plugin
export var sliderRange = "_rh-2";
export var sliderRoot = "_rh-0";
export var sliderThumb = "_rh-3";
export var sliderTrack = "_rh-1";